module.exports = __webpack_public_path__ + "static/img/goodness3.31826df0.png";